import type { IDropdownMenuConfig } from '../types';

import { merge } from '../../../helper';

import addClass from '../../../general/class/addClass';
import isEmptyArray from '../../../general/isEmpty/isEmptyArray';

import * as exElement from '../../../utils/element';

import { data } from '../utils';

// ----------------------------------------------------------------------------

function create(config: IDropdownMenuConfig = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const build: Record<string, any> = {};

    // ------------------------------------------------------------------------

    // Create element (ul)
    const elList = exElement.create({
        merge: defConfig,
        tag: 'ul',
        class: {
            new: 'dropdown-menu',
        },
    });
    build.element = elList;

    // ------------------------------------------------------------------------

    // Settings
    settings(build, defConfig);

    // ------------------------------------------------------------------------

    // Return
    return build;
}

function settings(build: Record<string, any>, config: Record<string, any> = {}): void {
    // If using data
    if (!isEmptyArray(config.data)) {
        // Create element (items)
        const dropdownItems = data(build.element, {
            merge: exElement.clear({ ...config }),
        });
        build.items = dropdownItems;
    }

    // ------------------------------------------------------------------------

    // If using menu alignment
    if (config.alignment && typeof config.alignment === 'string') {
        // Add class alignment
        addClass(build.element, 'dropdown-menu-' + config.alignment);
    }
}

// ----------------------------------------------------------------------------

export { create };
